import './CreateAreaContainer.svelte.css';
/* src/components/CreateAreaContainer.svelte generated by Svelte v3.37.0 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	detach,
	element,
	group_outros,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import { CreateAreaForm } from "./index.js";
import { areas } from "../stores/index.js";
import { MAX_AREA_COUNT } from "../data/constants.js";

function create_else_block(ctx) {
	let t;
	let createareaform;
	let current;
	let if_block = (!/*$areas*/ ctx[0] || !/*$areas*/ ctx[0].length) && create_if_block_1(ctx);
	createareaform = new CreateAreaForm({});

	return {
		c() {
			if (if_block) if_block.c();
			t = space();
			create_component(createareaform.$$.fragment);
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, t, anchor);
			mount_component(createareaform, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (!/*$areas*/ ctx[0] || !/*$areas*/ ctx[0].length) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_1(ctx);
					if_block.c();
					if_block.m(t.parentNode, t);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i(local) {
			if (current) return;
			transition_in(createareaform.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(createareaform.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(t);
			destroy_component(createareaform, detaching);
		}
	};
}

// (13:2) {#if $areas && $areas.length >= MAX_AREA_COUNT}
function create_if_block(ctx) {
	let p;

	return {
		c() {
			p = element("p");
			p.textContent = `${MAXED_TEXT}`;
			attr(p, "class", "no svelte-1etltsn");
		},
		m(target, anchor) {
			insert(target, p, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (16:4) {#if !$areas || !$areas.length}
function create_if_block_1(ctx) {
	let div;
	let t0;
	let t1;
	let a;
	let t2;
	let t3;
	let t4;
	let br;
	let t5;
	let t6;

	return {
		c() {
			div = element("div");
			t0 = text(BLURB_TEXT_1);
			t1 = space();
			a = element("a");
			t2 = text("Johnny•Decimal");
			t3 = space();
			t4 = text(BLURB_TEXT_2);
			br = element("br");
			t5 = space();
			t6 = text(BLURB_TEXT_3);
			attr(a, "class", "jd-inline-action");
			attr(a, "href", JD_URL);
			attr(a, "rel", "external");
			attr(div, "class", "blurb svelte-1etltsn");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);
			append(div, a);
			append(a, t2);
			append(div, t3);
			append(div, t4);
			append(div, br);
			append(div, t5);
			append(div, t6);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let current_block_type_index;
	let if_block;
	let current;
	const if_block_creators = [create_if_block, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*$areas*/ ctx[0] && /*$areas*/ ctx[0].length >= MAX_AREA_COUNT) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			div = element("div");
			if_block.c();
			attr(div, "class", "area-form-container svelte-1etltsn");
			toggle_class(div, "is-empty", !/*$areas*/ ctx[0] || !/*$areas*/ ctx[0].length);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if_blocks[current_block_type_index].m(div, null);
			current = true;
		},
		p(ctx, [dirty]) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(div, null);
			}

			if (dirty & /*$areas*/ 1) {
				toggle_class(div, "is-empty", !/*$areas*/ ctx[0] || !/*$areas*/ ctx[0].length);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if_blocks[current_block_type_index].d();
		}
	};
}

const MAXED_TEXT = "You already have 9 areas. Click an area name to show delete option.";
const BLURB_TEXT_1 = "Create and reorder your ";
const BLURB_TEXT_2 = " items";
const BLURB_TEXT_3 = "and generate a shareable, saveable index";
const JD_URL = "https://johnnydecimal.com/";

function instance($$self, $$props, $$invalidate) {
	let $areas;
	component_subscribe($$self, areas, $$value => $$invalidate(0, $areas = $$value));
	return [$areas];
}

class CreateAreaContainer extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default CreateAreaContainer;